import { Component, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { Subscription } from 'rxjs';
import { EventSourceService } from '../../../services/sse.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { NotificationResponse, ServerSentEvents, TxnTypes } from '../../interfaces/notifications.interface';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss',
  animations: [
    trigger('fade', [
      state('hidden', style({ opacity: 0, transform: 'translateY(100%)' })), // Initial hidden state
      state('visible', style({ opacity: 1, transform: 'translateY(0)' })), // Fully visible state
      transition('hidden => visible', [animate('500ms ease-out')]), // Appear animation
      transition('visible => hidden', [animate('500ms ease-in')]), // Disappear animation
    ]),
  ],
})
export class NotificationsComponent implements OnDestroy {
  subscriptions: Subscription[] = [];
  showNotification = false;
  fadeState = 'hidden';
  timeoutId!: ReturnType<typeof setInterval>;
  notificationData!: NotificationResponse;
  txnTypes = TxnTypes;

  constructor(
    private eventSourceService: EventSourceService,
    @Inject(PLATFORM_ID) private _platformId: Object,
  ) {
    const options = {}; //{ withCredentials: true };
    const eventNames = [ServerSentEvents.BOUGHT, ServerSentEvents.BOUGHT_AND_STAKED, ServerSentEvents.CLAIMED, ServerSentEvents.CLAIMED_AND_STAKED];

    if (isPlatformBrowser(this._platformId)) {
      this.subscriptions.push(
        this.eventSourceService.connectToServerSentEvents(environment.sseUrl, options, eventNames).subscribe({
          next: (data: any) => {
            this.notificationData = JSON.parse(data.data);
            this.displayNotification();
            console.log('**************Notifications Data************: ', this.notificationData);
          },
          error: (error: any) => {
            console.log('**************Notifications Error************: ', error);
          },
        }),
      );
    }
  }

  displayNotification() {
    this.showNotification = true;
    this.fadeState = 'visible';

    // Clear existing timeout if new notification arrives within 7 seconds
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    // Start timer to close the notification
    this.timeoutId = setTimeout(() => {
      this.fadeState = 'hidden'; // Trigger fade-out animation
    }, environment.notificationTimeout); // 7 seconds
  }

  handleAnimationEnd() {
    if (this.fadeState === 'hidden') {
      this.showNotification = false; // Hide the notification after animation ends
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
    this.eventSourceService.close();
  }
}
